import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import AddParentMasterDialog from './AddParentMaster';
import { useNavigate } from 'react-router-dom';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import ParentCard from './ParentCard';
import { InputSwitch } from 'primereact/inputswitch';
import ResetPassword from '../../ResetPassword/ResetPassword';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const ParentMaster = () => {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const [parentList, setParentList] = useState([]);
    const [masterData, setMasterData] = useState([]);
    const [classId, setParentId] = useState('');
    const [visible, setVisible] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [viewMode, setViewMode] = useState('card');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ParentId: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ParentName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Gender: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Phone: { value: null, matchMode: FilterMatchMode.CONTAINS },
        EmailId: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [visibleStudentList, setVisibleStudentList] = useState(false);
    const [masterStudentList, setMasterStudentList] = useState([]);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [isStatusConfirmation, setIsStatusConfirmation] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [updatedStatus, setUpdatedStatus] = useState('');
    const [updatedPassword, setUpdatedPassword] = useState('');
    const [isPasswordReset, setIsPasswordReset] = useState(false);
    const [accessList, setAccessList] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                Loader.show();
                const loginData = CommonConfig.loginData();
                setSecurityUserID(loginData?._id);
                await GetParentList(loginData?._id);
                await GetConfigurationData(loginData?._id);
            } catch (error) {
                Loader.hide();
                console.error('Error in useEffect:', error);
            } finally {
                Loader.hide();
            }
        };
        fetchData();
    }, []);

    const GetConfigurationData = async (id) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetPasswordConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setAccessList(res?.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const GetParentList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getParentDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setParentList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center'>
                    <Button icon="icon-view tailer-icon" className="e-sction-btn" onClick={() => navigate('/viewEdit-parent-master', { state: { userId: rows?._id, isEdit: false } })} />
                    <Button icon="pi pi-pencil" className="e-sction-btn p-mx-2" onClick={() => navigate('/viewEdit-parent-master', { state: { userId: rows?._id, isEdit: true } })} />
                    <Button icon="pi pi-trash" className="e-sction-btn" onClick={(e) => {
                        setIsDeleteConfirmation(true);
                        setDeleteId(rows._id);
                    }} />
                    <InputSwitch
                        checked={rows?.Status === 'Active' ? true : false}
                        onChange={(e) => {
                            toggleActiveStatus(rows._id, e.value);
                        }}
                        className="p-ml-2 p-mt-1"
                    />
                    {rows?.Phone && accessList?.IsParent &&
                        <Button icon="pi pi-key" className="e-sction-btn p-m-0 p-m-2" onClick={(e) => {
                            setIsPasswordReset(true);
                            setDeleteId(rows._id);
                        }} />}
                </div>
            </React.Fragment>
        );
    };

    const handleResetClose = () => {
        setIsPasswordReset(false)
    };

    const UpdateStatus = async () => {
        try {
            let data = {
                id: deleteId,
                Status: updatedStatus
            }
            await api.post(APIConstant.path.updateParentStatus, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Parent status updated successfully' });
                    setDeleteId('');
                    setUpdatedStatus('');
                    GetParentList(securityUserID);
                }
                handleCloseStatus();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                setUpdatedStatus('');
                handleCloseStatus();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const handleResetPassword = (id) => {
        setIsPasswordReset(true);
        setDeleteId(id);
    };

    const renderResetFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleResetClose}
            />
            <Button
                label="Update"
                className="btn-text-action-primary"
                onClick={(e) => UpdatePassword()}
            />
        </div>
    );

    const handlePasswordChange = (password) => {
        setUpdatedPassword(password);
    };

    const UpdatePassword = async () => {
        try {
            let data = {
                id: deleteId,
                Password: updatedPassword
            }
            await api.post(APIConstant.path.updatePassword, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Teacher password updated successfully' });
                    setDeleteId('');
                    setUpdatedPassword('');
                    await GetParentList(securityUserID);
                }
                handleResetClose();
            }).catch(err => {
                Loader.hide();
                Toast.error({ message: err?.message });
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const DeleteParent = async () => {
        try {
            let data = {
                id: deleteId
            }
            await api.post(APIConstant.path.deleteParent, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Parent deleted successfully' });
                    setDeleteId('');
                    setUpdatedStatus('');
                    GetParentList(securityUserID);
                }
                handleClose();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                setUpdatedStatus('');
                handleClose();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const toggleActiveStatus = (id, status) => {
        setDeleteId(id);
        setUpdatedStatus(status === true ? 'Active' : 'Inactive');
        setIsStatusConfirmation(true);
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={(e) => DeleteParent()}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const handleDelete = (id) => {
        setIsDeleteConfirmation(true);
        setDeleteId(id);
    };

    const renderStatusFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleCloseStatus}
            />
            <Button
                label="Update"
                className="btn-text-action-primary"
                onClick={(e) => UpdateStatus()}
            />
        </div>
    );

    const handleCloseStatus = () => {
        setIsStatusConfirmation(false)
    };

    const onCancel = () => {
        setVisible(false);
        setParentId('');
        setIsEdit(false);
        setMasterData([]);
        GetParentList(securityUserID);
    }

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const countBodyTemplateSrNo = (data, props) => {
        return <div onClick={() => {
            setVisibleStudentList(true);
            setMasterStudentList(data?.ChildrensList)
        }}>{data?.ChildrenCount}</div>
    };

    return (
        <div className='wayment-owner-dashboard'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-user"></i>
                    <h2>Parent Master</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                    <Button icon="pi pi-plus" className="e-h-btn" onClick={() => setVisible(true)} />
                    <Button
                        icon={viewMode === 'card' ? 'pi pi-bars' : 'pi pi-th-large'}
                        className="e-h-btn p-ml-2"
                        onClick={() => setViewMode(viewMode === 'card' ? 'list' : 'card')}
                    />
                </div>
            </div>
            <div className={viewMode === 'card' ? 'teacher-grid' : 'teacher-list'}>
                {viewMode === 'card' ? (
                    parentList.filter(x => x?.Name?.toLowerCase()?.includes(globalFilterValue.toLowerCase()) || x?.Email?.includes(globalFilterValue) || x?.Phone?.includes(globalFilterValue)).map(parent => (
                        <ParentCard key={parent._id} parent={parent} handleDelete={handleDelete} toggleActiveStatus={toggleActiveStatus} handlePassword={handleResetPassword} AccessList={accessList} />
                    ))
                ) : (
                    <DataTable
                        value={parentList}
                        paginator
                        rows={rows}
                        first={first}
                        filters={filters}
                        filterDisplay="menu"
                        globalFilterFields={['ParentId', 'Name', 'Gender', 'Phone', 'EmailId']}
                        responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        onPage={onPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'
                    >
                        <Column field="id" body={actionBodyTemplateSrNo} header="Sr No."  style={{width: '10%'}} />
                        <Column
                            field="ParentId"
                            header="Parent ID"
                             style={{width: '20%'}}
                        />
                        <Column
                            field="Name"
                            header="Name"
                             style={{width: '20%'}}
                        />
                        <Column
                            field="Gender"
                            header="Gender"
                             style={{width: '10%'}}
                        />
                        <Column
                            body={countBodyTemplateSrNo}
                            header="Childrens"
                             style={{width: '10%'}}
                        />
                        <Column
                            field="Phone"
                            header="Contact No."
                             style={{width: '20%'}}
                        />
                        <Column
                            field="Email"
                            header="Email ID"
                             style={{width: '20%'}}
                        />
                        <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '100%'}}/>
                    </DataTable>
                )}
            </div>
            <Dialog
                header={classId ? "Edit Parent Master" : "Add Parent Master"}
                className='dialog-popup'
                visible={visible}
                onHide={() => onCancel()}
                draggable={false}
                position="center"
                style={{ width: '50vw' }}
            >
                <AddParentMasterDialog onCancel={onCancel} />

            </Dialog>
            <Dialog
                visible={isPasswordReset}
                onHide={handleResetClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Reset Password</span>
                    </div>
                }
                footer={renderResetFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <ResetPassword onPasswordChange={handlePasswordChange} />
            </Dialog>
            <Dialog
                header="Childreen List"
                visible={visibleStudentList}
                onHide={() => {
                    setVisibleStudentList(false)
                    setMasterStudentList([]);
                }}
                draggable={false}
                position="center">

                <div className="p-col-12 p-card p-p-3">
                    <DataTable value={masterStudentList} paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rowsPerPageOptions={[10, 20, 50]} className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'>
                        <Column body={actionBodyTemplateSrNo} header="Sr No." />
                        <Column field="Name" header="Childreen Name" />
                        <Column field="Email" header="Email" />
                        <Column field="Phone" header="Phone" />
                    </DataTable>
                </div>
            </Dialog>

            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
            <Dialog
                visible={isStatusConfirmation}
                onHide={handleCloseStatus}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Status Update</span>
                    </div>
                }
                footer={renderStatusFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <div>
                    <p>
                        Are you sure you want to update status?
                    </p>
                </div>
            </Dialog>
        </div>
    );
};

export default ParentMaster;
